import { render, staticRenderFns } from "./TermGradesTable.vue?vue&type=template&id=34637a34&scoped=true&"
import script from "./TermGradesTable.vue?vue&type=script&lang=js&"
export * from "./TermGradesTable.vue?vue&type=script&lang=js&"
import style0 from "./TermGradesTable.vue?vue&type=style&index=0&id=34637a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34637a34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('34637a34', component.options)
    } else {
      api.reload('34637a34', component.options)
    }
    module.hot.accept("./TermGradesTable.vue?vue&type=template&id=34637a34&scoped=true&", function () {
      api.rerender('34637a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/grades/TermGradesTable.vue"
export default component.exports